import { Ship, Cog, Truck, UserPlus, FileText, Users, UserCog, ClipboardList, type LucideIcon } from 'lucide-react';
import type { QuickAddModule } from './moduleTheme';
import type { QuickAddDialogKey } from '@/state/quickAddStore';

export type QuickAddAction = {
  id: QuickAddDialogKey;
  label: string;
  module: QuickAddModule;
  icon: LucideIcon;
  kind: 'dialog';
};

export const QUICK_ADD_ACTIONS: ReadonlyArray<QuickAddAction> = [
  { id: 'employee', label: 'Add Employee', module: 'core',      icon: UserCog,  kind: 'dialog' },
  { id: 'boat',     label: 'Add Boat',     module: 'inventory', icon: Ship,     kind: 'dialog' },
  { id: 'engine',   label: 'Add Engine',   module: 'inventory', icon: Cog,      kind: 'dialog' },
  { id: 'trailer',  label: 'Add Trailer',  module: 'inventory', icon: Truck,    kind: 'dialog' },
  { id: 'lead',     label: 'Add Deal',     module: 'crm',       icon: UserPlus, kind: 'dialog' },
  { id: 'quote',    label: 'Create Quote', module: 'crm',       icon: FileText, kind: 'dialog' },
  { id: 'customer', label: 'Add Customer', module: 'crm',       icon: Users,    kind: 'dialog' },
  { id: 'work_order', label: 'New Work Order', module: 'service', icon: ClipboardList, kind: 'dialog' },
];
